import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalService } from 'src/app/core/services/modal.service';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { AppModalComponent } from 'src/app/shared/components/app-modal/app-modal.component';
import { Location } from '@angular/common';
import { AppInputComponent, InputType } from 'src/app/shared/components/app-input/app-input.component';
import { AuthService } from 'src/app/core/services/auth.service';
import { AlertService, AlertType } from 'src/app/core/services/alert.service';

@Component({
  selector: 'app-recover-password',
  standalone: true,
  imports: [AppButtonComponent, AppInputComponent, ReactiveFormsModule, AppModalComponent],
  templateUrl: './recover-password.component.html',
  styleUrl: './recover-password.component.scss'
})
export class RecoverPasswordComponent implements OnInit{

  InputType = InputType;
  loginDependent: any = false;

  recoverStep: any = 'EMAIL';
  receivedCode = '';
  dependentData: any;



  logoUrl: string = localStorage.getItem('imageLogo') || '';
  pageTitle = 'Insira abaixo o Email da conta para envio de redefinição de senha.';
  modalId = 'recoverPassModalId';

  passwordFormGroup = new FormGroup({
    code: new FormControl('', Validators.required),
    newPassword: new FormControl('', [Validators.required, Validators.minLength(6)]),
  });

  recoverPassFormGroup = new FormGroup({
    emailControl: new FormControl<string>('', [Validators.required, Validators.email]),
  });

  buttonOptions = {
    buttonText: 'Voltar',
    buttonBorderWidth: '1px',
    buttonSize: 'btn btn-md px-3 btn-secondary',
    borderRadius: '25px'
  };

  recoverPassBtn = {
    buttonText: 'Enviar e-mail',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm px-5 btn-primary',
    btnDisabledBackground: '#f2e2b2',
    btnDisabledTextColor: '#000000'
  };

  codeBtn = {
    buttonText: 'Validar código',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm px-5 btn-primary',
    btnDisabledBackground: '#f2e2b2',
    btnDisabledTextColor: '#000000'
  };

  resendBtn = {
    buttonText: 'Reenviar código',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm px-5 btn-primary',
    btnDisabledBackground: '#f2e2b2',
    btnDisabledTextColor: '#000000'
  };

  resetBtn = {
    buttonText: 'Alterar senha',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm px-5 btn-primary',
    btnDisabledBackground: '#f2e2b2',
    btnDisabledTextColor: '#000000'
  };

  // TODO: Se o email não existir, exibir mensagem: E-mail inexistente em nossa base.
  modalBodyMessage = 'Um e-mail com as instruções de troca de senha foram enviadas para o seu e-mail';

  constructor(
    private modalService: ModalService,
    private location: Location,
    private alertService: AlertService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.loginDependent = history.state.loginDependent;
  }

  recoverPassword() {
    if(this.recoverPassFormGroup.invalid) {
      return;
    }
    let email = this.recoverPassFormGroup.get('emailControl')?.value as string;

    if(this.loginDependent){
      this.authService.sendResetCodeDependent(email).subscribe(() => {
        this.recoverStep = 'CODE';
        this.pageTitle= "Insira o Código recebido no email para prosseguir com a redefinição de senha";
        this.alertService.showAlert(
          AlertType.INFO,
          'Foi enviado no email informado um código de validação para redefinir a senha.'
        );
      });
    } else{
      this.authService.recoverPassword(email).subscribe(
      () => this.openModal(this.modalId)
    );
    }

    // TODO: Fazer request para enviar email -> se existir -> abrir o modal
    // se não existir -> mostrar alert e voltar para login
    // this.openModal(this.modalId);
  }

  validateCode() {
    if (this.passwordFormGroup.get('code')?.invalid) return;

    const code = this.passwordFormGroup.get('code')?.value!;
    let email = this.recoverPassFormGroup.get('emailControl')?.value as string;

    this.authService.validateResetCode(email,code).subscribe((res: any) => {
      this.dependentData = res;
      this.recoverStep = 'NEW_PASSWORD';
      this.pageTitle= "Insira a nova senha e confirme"
    });
  }

  changePassword() {
    if (this.passwordFormGroup.get('newPassword')?.invalid) return;



    const newPassword = this.passwordFormGroup.get('newPassword')?.value!;

    const body = {
      newPassword : newPassword,
      idDependent : this.dependentData.id
    }

    this.authService.changeDependentPassword(body).subscribe(() => {
      this.alertService.showAlert(
          AlertType.SUCCESS,
          'Senha redefinida com sucesso, realize o login novamente!'
        );
        this.location.back();
    });
  }

  openModal(modalId: string) {
    this.modalService.open(modalId);
  }

  onModalConfirm(): void {
    this.location.back();
  }

  back() {
    this.location.back();
  }
}

